import ConfigModel from "./ConfigModel";
import UserModel from "./UserModel";
import getCARTOData from "@/store/utils/getCARTOData";

export function getCartoModels() {
  const CARTOData = getCARTOData();

  const configModel = new ConfigModel({
    ...CARTOData.config,
    base_url: CARTOData.user_data.base_url,
  });
  const userModel = new UserModel(CARTOData.user_data);
  const cartoModels = {
    config: configModel,
    user: userModel,
  };
  return cartoModels
}